export const buildW9TrackingFilterGroups = (filterOptions = {}) => [
  {
    id: 'w9_status',
    label: 'W-9 Status',
    filters: [
      {
        id: 'w9_status',
        label: 'W-9 Status',
        type: 'checkbox',
        options: (filterOptions.w9_status_options || [
          { value: 'all', label: 'All' },
          { value: 'has', label: 'Has W-9' },
          { value: 'missing', label: 'Missing W-9' },
        ]).map(o => ({ value: String(o.value), label: o.label })),
      },
    ],
  },
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
    ],
  },
];
